import { Pipe, PipeTransform } from '@angular/core';
import { formatAmount } from '../helpers/balance.helper';

@Pipe({ name: 'balanceAmount', standalone: true })
export class BalanceAmountPipe implements PipeTransform {
  /**
   * `value` accepts strings as well as numbers: order money fields (FX legs, frozen
   * quantities) come off the API as decimal strings.
   */
  transform(
    value: string | number | null | undefined,
    currency: string
  ): string {
    if (value === null || value === undefined || value === '') return '-';
    return formatAmount(currency ?? '', Number(value));
  }
}
